<!-- START Student form -->

<form class="sidebar__form" [formGroup]="form">

	<h2 class="pax-title-h2">
		{{'bookingDetails.titles.studentFare' | ibeadmin:'sync'}}
	</h2>
	<p class="muted bottom-gap">
		{{'bookingDetails.label.studentFareInfo' | ibeadmin:'sync'}}
	</p>
						
	<div class="form--edit-mode">
		<div class="form-field--row grid no-padding">
			
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="student--document_number">
					{{'bookingDetails.label.idDocumentNumber' | ibeadmin:'sync'}}
				</label>
				<input 
					class="input-text"
					formControlName="studentDocNumber" 
					aria-describedby="student_document_number-error"
					id="student--document_number" />
				<span 
					aria-live="polite" 
					class="input-error" 
					id="student_document_number-error" 
					role="alert"
					[attr.aria-label]="formStudentErrors('studentDocNumber')"
					*ngIf="form.controls['studentDocNumber'].invalid && displayValidationMessages">
					{{ formStudentErrors('studentDocNumber') | ibeadmin:'sync' }}
				</span>
			</div>
			
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="student--fiscal_number">
					{{'bookingDetails.label.fiscalNumber' | ibeadmin:'sync'}}
				</label>
				<input 
					class="input-text"
					formControlName="studentfiscalNumber" 
					aria-describedby="student_fiscal_number-error"
					id="student--fiscal_number" />
				<span 
					aria-live="polite" 
					class="input-error" 
					id="student_fiscal_number-error" 
					role="alert"
					[attr.aria-label]="formStudentErrors('studentfiscalNumber')"
					*ngIf="form.controls['studentfiscalNumber'].invalid && displayValidationMessages">
					{{ formStudentErrors('studentfiscalNumber') | ibeadmin:'sync' }}
				</span>
			</div>
		</div>
		
		<div class="form-field--row">
			<div class="form-field">
				<app-checkbox-input-indra
					id="student--confirm"
					formControlName="student_confirm"
					label="{{'bookingDetails.label.studentRulesConfirm' | ibeadmin:'sync'}}">
				</app-checkbox-input-indra>
				
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formStudentErrors('student_confirm')"
					*ngIf="form.controls['student_confirm'].invalid && displayValidationMessages">
					{{ formStudentErrors('student_confirm') | ibeadmin:'sync' }}
				</span>
			</div>
		</div>
		
		<p class="bold top-gap">
			{{'bookingDetails.label.eligibleStudentInfo' | ibeadmin:'sync'}}
		</p>
		<ul class="unordered-list top-gap">
			<li>
				{{'bookingDetails.label.studentFare1' | ibeadmin:'sync'}}
			</li>
			<li>
				{{'bookingDetails.label.studentFare2' | ibeadmin:'sync'}}
			</li>
			<li>
				{{'bookingDetails.label.studentFare3' | ibeadmin:'sync'}}
			</li>
		</ul>
		<p class="muted bottom-gap top-gap">
			{{'bookingDetails.label.tapReservesToCancel' | ibeadmin:'sync'}}
		</p>
		
		<hr class="separator">
	</div>
</form>	
		
<!-- END Student form -->